const initialState =
{
	privateMessages   : {},
	order             : 'asc',
	totalCount        : 0,
	totalUnreadCount  : 0,
	activeParticipant : {},
	activeTab         : 'chat'

};

const privateChat = (state = initialState, action) =>
{
	switch (action.type)
	{
		case 'ADD_PRIVATE_MESSAGE': {
			const { messageObj } = action.payload;
			const { toId, message, displayName, picture } = messageObj;
			const messagesForToId = state.privateMessages[toId];

			if (messagesForToId)
			{
				return {
					...state,
					privateMessages : {
						...state.privateMessages,
						[toId] : {
							...messagesForToId,
							messages    : [ ...messagesForToId?.messages, message ],
							displayName,
							picture,
							recentTime  : message.time,
							count       : messagesForToId.count+1,
							countUnread : message?.isRead ? Number(messagesForToId?.countUnread): (Number(messagesForToId.countUnread) || 0) + 1
						}
					},
					totalUnreadCount : message?.isRead ? state.totalUnreadCount : ++state.totalUnreadCount
				};
			}
			else
			{
				return {
					...state,
					privateMessages : {
						...state.privateMessages,
						[toId] : {
							messages    : [ message ],
							displayName,
							picture,
							recentTime  : message.time,
							count       : 1,
							countUnread : message?.isRead? 0 : 1
						}
					},
					totalUnreadCount : message?.isRead ? state.totalUnreadCount : ++state.totalUnreadCount
				};
			}
		}
		case 'SET_IS_MESSAGE_READ':
		{
			const { id } = action.payload;
			const messagesForToId = state.privateMessages[id];

			if (messagesForToId)
			{
				return { ...state,
					privateMessages : {
						...state.privateMessages,
						[id] : {
							...messagesForToId,
							countUnread : 0

						}
					},
					totalUnreadCount : state.totalUnreadCount-messagesForToId.countUnread

				};

			}
			else
			{
				return {
					...state
				};
			}

		}
		case 'ADD_ACTIVE_PARTICIPANT': {
			const { participantObj } = action.payload;

			return {
				...state,
				activeParticipant : participantObj
			};
		}
		case 'ADD_ACTIVE_TAB': {
			const { tabName } = action.payload;

			return {
				...state,
				activeTab : tabName
			};
		}
		case 'REMOVE_CHAT': {
			const { id } =action.payload;
			const messagesForToId = state.privateMessages[id];
			const newState = { ...state };

			if (messagesForToId)
			{
				newState.totalUnreadCount= newState.totalUnreadCount-messagesForToId.countUnread;
				delete newState.privateMessages[id];
			}

			return { ...newState, privateMessages: { ...newState.privateMessages } };

		}
		default:
			return state;
	}
};

export default privateChat;
